/* Integracje — provider rows. The groups, rows and button paints are `AccountScreen.module.css`'s;
 * this file draws the row's leading mark, its two lines and the wait.
 *
 * Every colour, space, radius and type value is a token; heights and widths are layout. */

/* Every provider row leads with the same neutral tile, so the column of marks lines up: Google's
 * brand mark, or Apple's and the call link's outline glyph. */
.tile {
  display: grid;
  flex: none;
  place-items: center;
  width: var(--sz-account-provider);
  height: var(--sz-account-provider);
  color: var(--text-2);
  background: var(--bg-sunken);
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-8px);
}

.tileGlyph {
  display: block;
  width: var(--sz-account-glyph-md);
  height: var(--sz-account-glyph-md);
}

/* Google's mark inside the tile: a filled square, so a little larger than the outline glyphs. */
.brandGlyph {
  display: block;
  width: var(--sz-account-brand-mark);
  height: var(--sz-account-brand-mark);
}

.title {
  display: block;
  font-size: var(--fs-button-sm);
  font-weight: var(--fw-semibold);
  color: var(--text);
}

.status {
  display: block;
  margin-top: var(--space-1px);
}

/* The expired connection's line, in warn ink with its triangle — never colour alone. */
.broken {
  display: flex;
  gap: var(--space-2);
  align-items: baseline;
  color: var(--warn-ink);
}

.warning {
  flex: none;
  width: var(--sz-account-glyph-sm);
  height: var(--sz-account-glyph-sm);
}

/* The wait inside Google's row: one line of status. */
.statusBar {
  display: block;
  width: 60%;
  height: var(--fs-note);
  margin-top: var(--space-1);
}

/* A refusal under a row, inside the group, inset to the row's own edges. */
.rowBanner {
  padding: var(--space-0) var(--space-18px) var(--space-3);
}

.section {
  margin-top: var(--space-5);
}

.failure {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  align-items: flex-start;
}
